export default "__VITE_ASSET__B3p7tZt3__"